<app-alert></app-alert>

<router-outlet windowResize></router-outlet>
<div class="window-resize-helper" (window:resize)="onResize()"></div>
